import { render, staticRenderFns } from "./rooms-list.vue?vue&type=template&id=3ee52134"
import script from "./rooms-list.vue?vue&type=script&lang=js"
export * from "./rooms-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports